import { Link } from "react-router-dom";

const Missing = () => {
  return (
    <article className="App2" style={{ padding: "2rem", textAlign: "center" }}>
      <h1 className="title">Oops!</h1>
      <p className="Paragraph">This page doesn’t exist.</p>
      <div className="flexGrow">
        <Link to="/" className="buttonbook" style={{ display: "inline-block" }}>
          Back to Home
        </Link>
      </div>
    </article>
  );
};

export default Missing
